<template>
  <section>
    <filters />
    <stats-table />
  </section>
</template>

<script>
  import Filters from './filter/stats-filter';
  import StatsTable from './stats-table';
  export default {
    components: { Filters, StatsTable }
  };
</script>
